import React, { Component, createContext } from 'react';

// Due to new version migration (16 -> 19) changed react.createContext to createContext.
export const CurrentUserContext = createContext({});

export class CurrentUserProvider extends Component {
  state = {
    currentUser: null,
    currentPatient: null,
    currentProvider: null,
    activeProvider: null,
    currentAdministrator: null,
  };

  componentDidMount() {
    const { value: currentUser } = this.props;
    this.setCurrentUser(currentUser);
  }

  componentDidUpdate({ value: oldCurrentUser }) {
    const { value: currentUser } = this.props;
    if (currentUser.id !== oldCurrentUser.id) {
      this.setCurrentUser(currentUser);
    }
  }

  setCurrentUser = currentUser => {
    if (currentUser.isProvider) {
      this.setState(state => ({
        ...state,
        currentUser,
        activeProvider: {
          ...currentUser,
          ...currentUser.provider,
        },
        currentProvider: {
          ...currentUser,
          ...currentUser.provider,
        },
      }));
    } else if (currentUser.isPatient) {
      this.setState(state => ({
        ...state,
        currentUser,
        currentPatient: {
          ...currentUser,
          ...currentUser.patient,
        },
      }));
    } else if (currentUser.isAdministrator) {
      const activeProvider = currentUser.administrator.providers[0];
      this.setState(state => ({
        ...state,
        currentUser,
        activeProvider: {
          id: activeProvider.id,
          name: activeProvider.name,
          tenancies: activeProvider.tenancies,
        },
        currentAdministrator: {
          ...currentUser,
          ...currentUser.administrator,
        },
      }));
    }
  };

  render() {
    const { children } = this.props;
    const {
      currentUser,
      currentPatient,
      currentProvider,
      currentAdministrator,
      activeProvider,
    } = this.state;
    return (
      <CurrentUserContext.Provider
        value={{
          currentUser,
          currentPatient,
          currentProvider,
          currentAdministrator,
          activeProvider,
          setCurrentUser: this.setCurrentUser,
        }}
      >
        {children}
      </CurrentUserContext.Provider>
    );
  }
}

export const CurrentUserConsumer = CurrentUserContext.Consumer;

export default CurrentUserContext;
